import { UserOrder } from "../models/User";

const storage: Storage = window.localStorage;

const StateKey = "user_order.state";

export const Storage = {
  get userOrder(): UserOrder | undefined {
    let val = storage.getItem(StateKey);
    return val ? JSON.parse(val) : undefined;
  },

  set userOrder(value: UserOrder | undefined) {
    if (!value) {
      storage.removeItem(StateKey);
    } else {
      storage.setItem(StateKey, JSON.stringify(value));
    }
  }
};
